var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bg-hui"},[_c('div',{staticClass:"cash-out-box"},[_c('p',[_vm._v(" 您今日可以提现了，今日提现不能超过"+_vm._s(_vm.data.dailyWithdrawCount)+"次，提现总额不能超过"+_vm._s(_vm.data.dailyTotalWithdrawMoney)+"元 ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }